'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { CompetitionStatusEnum } from '@flipster/apis/v2/trading-competition/types';
import { vstack } from '@flipster/styled-system/patterns';

import { competitionApiBunja } from '../../state';
import { Rules } from '../rules';
import { PricePredictionMilestone } from './milestone';
import { PricePredictionCard } from './prediction-card';
import { PredictionHistory } from './prediction-history';
import { ResultAnnouncementCard } from './result-announcement-card';
import { resultAnnouncementCardBunja } from './result-announcement-card.state';
import { pricePredictionBunja } from './state';

export const PricePredictionContent = () => {
  return (
    <>
      <PricePrediction />
      <Rules />
    </>
  );
};

const PricePrediction = () => {
  const { pricePredictionAtom } = useBunja(pricePredictionBunja);
  const { showResultAnnouncementAtom } = useBunja(resultAnnouncementCardBunja);
  const { competitionStatusAtom } = useBunja(competitionApiBunja);

  const prediction = useAtomValue(pricePredictionAtom);
  const showResultAnnouncement = useAtomValue(showResultAnnouncementAtom);
  const competitionStatus = useAtomValue(competitionStatusAtom);

  const isUpcoming = competitionStatus === CompetitionStatusEnum.Upcoming;
  const isFinished = prediction?.pricePredictionStatus === 'FINISHED';

  if (isFinished) {
    return (
      <div className={vstack({ gap: 40, w: '100%' })}>
        <PredictionHistory />
      </div>
    );
  }

  return (
    <div className={vstack({ gap: 40, w: '100%' })}>
      <PricePredictionCard />
      {showResultAnnouncement && <ResultAnnouncementCard />}
      {!isUpcoming && <PredictionHistory />}
      <PricePredictionMilestone />
    </div>
  );
};
